import { render, staticRenderFns } from "./mobileNews.vue?vue&type=template&id=7b2c2ff8&scoped=true&"
import script from "./mobileNews.vue?vue&type=script&lang=js&"
export * from "./mobileNews.vue?vue&type=script&lang=js&"
import style0 from "./mobileNews.vue?vue&type=style&index=0&id=7b2c2ff8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2c2ff8",
  null
  
)

export default component.exports